import 'bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AuthChecker from './Routes/AuthenticationChecker';

import NotFound from './Pages/NotFound';

import AdminRoute from './Routes/Admin';
import SalesRoute from './Routes/Sales';
import CallerRoute from './Routes/Caller';
import TeamRoute from './Routes/Team';
import PublisherRoute from './Routes/Publisher';
import AuthRoute from './Routes/Auth';
import Loader from './Pages/Loader';
import SignIn from './Pages/Auth/Signin';
import SalesDashboard from './Pages/Sales/Dashboard';
import Signup from './Pages/Auth/Signup';
import ForgotPassword from './Pages/Auth/ForgotPassword';
import ResetPassword from './Pages/Auth/ResetPassword';
import Protection from './utils/Protection';

const App = () => { 

	return(	
		
	<AuthProvider>
		<Protection />
		
    	<Router>
        
			<Routes>
				<Route path="/sign-in" element={<SignIn />} />
				<Route path="/" element={<SignIn />} />
				<Route path="/forgot-password" element={<ForgotPassword />} />
				<Route path="/password/reset/:token" element={<ResetPassword />} />
				{/*<Route path="/reset-password" element={<ResetPassword />} />*/}
				<Route path="/sign-up" element={<Signup />} />

				{AdminRoute.map((route, index) => (
					<Route key={index} path = {route.path} element={
												<AuthChecker allowedRoles={[1]}>
													{route.element}
												</AuthChecker>
												} />
				
				))}

				{SalesRoute.map((route, index) => (
					<Route key={index} path = {route.path} element={
												<AuthChecker allowedRoles={[2]}>
													{route.element}
												</AuthChecker>
												} />
				
				))}

				{CallerRoute.map((route, index) => (
					<Route key={index} path = {route.path} element={
												<AuthChecker allowedRoles={[3]}>
													{route.element}
												</AuthChecker>
												} />
				
				))}

				{TeamRoute.map((route, index) => (
					<Route key={index} path = {route.path} element={
												<AuthChecker allowedRoles={[4]}>
													{route.element}
												</AuthChecker>
												} />
				
				))}

				{PublisherRoute.map((route, index) => (
					<Route key={index} path = {route.path} element={
												<AuthChecker allowedRoles={[5]}>
													{route.element}
												</AuthChecker>
												} />
				
				))}

				
            
        	</Routes>
    	</Router>
	</AuthProvider>
    );

}

export default App;
